const listaUsoCFDI = [
  {
    id_Cfdi_Uso: 1,
    Clave: "G01",
    Descripcion: "Adquisición de mercancias",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 2,
    Clave: "G02",
    Descripcion: "Devoluciones, descuentos o bonificaciones",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 3,
    Clave: "G03",
    Descripcion: "Gastos en general",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 4,
    Clave: "I01",
    Descripcion: "Construcciones",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 5,
    Clave: "I02",
    Descripcion: "Mobilario y equipo de oficina por inversiones",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 6,
    Clave: "I03",
    Descripcion: "Equipo de transporte",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 7,
    Clave: "I04",
    Descripcion: "Equipo de computo y accesorios",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 8,
    Clave: "I05",
    Descripcion: "Dados, troqueles, moldes, matrices y herramental",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 9,
    Clave: "I06",
    Descripcion: "Comunicaciones telefónicas",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 10,
    Clave: "I07",
    Descripcion: "Comunicaciones satelitales",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 11,
    Clave: "I08",
    Descripcion: "Otra maquinaria y equipo",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 12,
    Clave: "D01",
    Descripcion: "Honorarios médicos, dentales y gastos hospitalarios.",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 13,
    Clave: "D02",
    Descripcion: "Gastos médicos por incapacidad o discapacidad",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 14,
    Clave: "D03",
    Descripcion: "Gastos funerales",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 15,
    Clave: "D04",
    Descripcion: "Donativos",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 16,
    Clave: "D05",
    Descripcion:
      "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 17,
    Clave: "D06",
    Descripcion: "Aportaciones voluntarias al SAR",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
  {
    id_Cfdi_Uso: 18,
    Clave: "D07",
    Descripcion: "Primas por seguros de gastos médicos",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 19,
    Clave: "D08",
    Descripcion: "Gastos de transportación escolar obligatoria",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 20,
    Clave: "D09",
    Descripcion:
      "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 21,
    Clave: "D10",
    Descripcion: "Pagos por servicios educativos (colegiaturas)",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: false,
  },
  {
    id_Cfdi_Uso: 22,
    Clave: "P01",
    Descripcion: "Por definir",
    Aplica_Personas_Fisicas: true,
    Aplica_Personas_Morales: true,
  },
]

export { listaUsoCFDI }
